import { OptionItem } from '@app/components/ui/select/select.type';
import useTranslation from '@app/hooks/use-translation';
import {
  useGetAliasesListQuery,
  useGetCurrentAliasIdSettingQuery,
  useSetAliasIdSettingForQMMutation,
} from '@app/store/api/alias-settings-page.api';
import { CircleButton, Select } from '@ui';
import React, { useMemo, useState } from 'react';

const AliasForOperator = () => {
  const { t } = useTranslation('pages.settings');
  const [editAlias, setEditAliasState] = useState(false);
  const [selectValue, setSelectValue] = useState<string>();
  const { data: aliases } = useGetAliasesListQuery();
  const { data: currentAlias } = useGetCurrentAliasIdSettingQuery();
  const [setAliasForQm] = useSetAliasIdSettingForQMMutation();
  const options = useMemo(() => {
    const result: OptionItem[] = [];
    for (let i = 0; i < (aliases?.aliases?.length || 0); i++) {
      const curAlias = aliases?.aliases?.[i];
      if (curAlias?.type_meta !== 'record' || curAlias?.type_value !== 'str') {
        continue;
      }
      result.push({ value: curAlias.alias_id, title: curAlias.name });
    }
    return result;
  }, [aliases?.aliases]);

  function handleApproveNewAlias() {
    if (!selectValue) return;
    setAliasForQm({ alias_id: selectValue });
    setEditAliasState(false);
  }

  return (
    <div className="inline-flex items-center w-full justify-between py-[30px]">
      <div className="flex items-center gap-[10px]">
        <h3 className="text-[18px] font-[700] ml-[20px]">{t('common_setting.alias_id_title')}</h3>
        <div className="flex items-center">
          <div
            className={`flex items-center transition-all bold text-[18px] ${
              editAlias && 'hidden'
            } `}
          >
            {currentAlias?.name || '-'}
          </div>
          <div className={`flex items-center transition-all ${!editAlias && 'hidden'} `}>
            <div className="w-[300px]">
              <Select
                defaultValue={selectValue || currentAlias?.alias_id}
                onChange={(value) => setSelectValue(value as string)}
                options={options}
              />
            </div>
            <div className="flex items-center gap-[5px]">
              <CircleButton
                className="text-basic_green"
                onClick={handleApproveNewAlias}
                icon="CheckIcon"
              />
              <CircleButton
                className="text-basic_red"
                onClick={() => setEditAliasState(false)}
                icon="XIcon"
              />
            </div>
          </div>
        </div>
        {!editAlias && <CircleButton onClick={() => setEditAliasState(true)} icon="EditIcon" />}
      </div>
    </div>
  );
};

export default AliasForOperator;
